export default __webpack_public_path__ + "static/media/timeline.181a55f6.svg";